import { render, staticRenderFns } from "./ReSingle.vue?vue&type=template&id=f96fe446&"
import script from "./ReSingle.vue?vue&type=script&lang=js&"
export * from "./ReSingle.vue?vue&type=script&lang=js&"
import style0 from "./ReSingle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports